import './Andre.css'
import 'leaflet/dist/leaflet.css';

import { useState, useCallback, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../authContext';
import CircularProgress from '@mui/material/CircularProgress';
import FileUpload from '../../components/FileUpload';
import MapVisualizer from '../../components/MapaVisualizer';
import DownloadGeoButton from '../../components/DownloadButton';


function Andre() {

    const { t } = useTranslation('database');
    const { accessToken, email, sessionId } = useContext(AuthContext);

    const location = useLocation();
    const assistantId = location.state?.assistantId || {};

    const [documentList, setDocumentList] = useState([]);
    const [uploadingFilesList, setUploadingFilesList] = useState([]);
    const [files, setFiles] = useState([]);  // arquivos selecionados
    const [isUploading, setIsUploading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [rawTable, setRawTable] = useState("");
    const [report, setReport] = useState("");
    const [activeTab, setActiveTab] = useState("tabela");
    const [geojson, setGeojson] = useState(null);
    const uploadingFilesRef = useRef(uploadingFilesList);

    uploadingFilesRef.current = uploadingFilesList;

    // Recebe arquivos do FileUpload
    const handleFilesSelected = (selectedFiles) => {
        const newFiles = Array.from(selectedFiles);

        // Adiciona os arquivos na lista exibida
        const formatted = newFiles.map(f => ({
            file: f,
            filename: f.name
        }));

        //setFiles(prev => [...prev, ...formatted]);


        // Adiciona na lista de upload 
        setUploadingFilesList(prev => [...prev, ...formatted]);
    };


    const formatBold = (text) => {
        const parts = text.split(/(\*\*.*?\*\*)/g);
        return parts.map((part, i) =>
            part.startsWith("**") && part.endsWith("**") ? (
                <strong key={i}>{part.slice(2, -2)}</strong>
            ) : (
                part
            )
        );
    };

    const renderMarkdownTables = (markdown) => {
        // Divide por blocos de tabela separados
        console.log(markdown);
        console.log(typeof markdown);

        const tableBlocks = markdown
            .split("\n\n")
            .filter(block => block.trim().startsWith("|"));

        return tableBlocks.map((block, index) => {
            const lines = block
                .trim()
                .split("\n")
                .filter(line => {
                    const normalized = line.replace(/\s/g, "");
                    return !/^(\|[:\-]+)+\|?$/.test(normalized);
                });

            const normalizedTable = lines.join("\n");

            return renderTable(normalizedTable, index);
        });
    };


    const renderTable = (raw) => {
        if (!raw) return <p>Nenhuma tabela retornada.</p>;

        const lines = raw
            .split("\n")
            .map((l) => l.trim())
            .filter(Boolean);

        // remove a linha separadora Markdown
        const cleanLines = lines.filter(
            (line) => !/^(\s*\|\s*-+)+\s*\|?$/.test(line)
        );

        const rows = cleanLines.map((line) =>
            line
                .trim()
                .split("|")
                .map((c) => c.trim())
                .filter(Boolean)
        );

        if (rows.length === 0) return <p>Tabela inválida.</p>;

        const [header, ...body] = rows;

        return (
            <div className="table-wrapper">
                <table className="chat-table">
                    <thead>
                        <tr>
                            {header.map((cell, i) => (
                                <th key={i}>{formatBold(cell)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {body.map((row, ri) => (
                            <tr key={ri}>
                                {row.map((cell, ci) => (
                                    <td key={ci}>{formatBold(cell)}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );

    };

    const handleAnalyze = useCallback(async () => {
        const currentFiles = uploadingFilesRef.current;

        if (!currentFiles || currentFiles.length === 0) {
            setErrorMessage("Envie ao menos um arquivo.");
            return;
        }

        setLoading(true);
        setErrorMessage("");

        const formData = new FormData();

        currentFiles.forEach(file => {
            formData.append("files", file.file);
        });
        formData.append("session_id", sessionId);
        formData.append("user", email);
        formData.append("assistant_id", assistantId);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/analyze`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    body: formData,
                }
            );

            const data = await response.json();
            console.log(data);

            if (!response.ok) {
                setErrorMessage(data.error || "Erro ao analisar arquivos.");
                setLoading(false);
                return;
            }


            if (data.docs) {
                setDocumentList(prev => [...prev, ...data.docs]);
            }

            if (data.raw_markdown_table) {
                setRawTable(data.raw_markdown_table);
            }

            if (data.report) {
                setReport(data.report);
            }
            if (data.geojson) {
                console.log("GeoJSON recebido:", data.geojson);
                setGeojson(data.geojson);
            }

            if (data.failed_files?.length) {
                setUploadingFilesList(prev =>
                    prev.filter(
                        file => !data.failed_files.includes(file.filename)
                    )
                );
            } else {
                setUploadingFilesList([]);
            }

        } catch (err) {
            console.error(err);
            setErrorMessage("Erro ao enviar arquivos.");
        } finally {
            setLoading(false);
        }
    }, [files, accessToken, sessionId, email, assistantId]);



    // BOTÕES DE COPIAR
    const copyTable = () => {
        navigator.clipboard.writeText(rawTable || "");
    };

    const copyText = () => {
        navigator.clipboard.writeText(report || "");
    };

    return (
        <div className='automation-body'>
            <div className='automation-margem'>
                <div className='automation-upload'>

                    <FileUpload
                        onFilesSelected={handleFilesSelected}
                        uploadingFiles={uploadingFilesList}          // lista de uploads em andamento
                        documentList={documentList}            // lista de documentos já enviados
                        onDeleteDocument={(doc) => console.log("Remover", doc)}
                        isUploading={loading}
                        acceptedTypes={['.pdf']}
                    />
                    <button
                        className='category-gray-button'
                        onClick={handleAnalyze}
                        disabled={loading}

                    >
                        {t('analyze')}
                    </button>


                </div>
                {/* RESULTADOS */}

                <div className="automation-results">
                    <div className="tabs-header">
                        <button
                            className={`tab-button ${activeTab === "tabela" ? "active" : ""}`}
                            onClick={() => setActiveTab("tabela")}
                        >
                            Tabela
                        </button>
                        <button
                            className={`tab-button ${activeTab === "texto" ? "active" : ""}`}
                            onClick={() => setActiveTab("texto")}
                        >
                            Texto
                        </button>
                        <button
                            className={`tab-button ${activeTab === "mapa" ? "active" : ""}`}
                            onClick={() => setActiveTab("mapa")}
                        >
                            Mapa
                        </button>

                        {/* Botão de copiar alinhado à direita */}
                        <div className="tabs-actions">
                            {activeTab === "tabela" && (
                                <button className="feedback-button" onClick={copyTable} disabled={loading}>
                                    <img src="/imagens/copy.svg" alt="Copy Icon" className="feedback-icon" />
                                </button>
                            )}
                            {activeTab === "texto" && (
                                <button className="feedback-button" onClick={copyText} disabled={loading}>
                                    <img src="/imagens/copy.svg" alt="Copy Icon" className="feedback-icon" />
                                </button>
                            )}
                            {activeTab === "mapa" && (
                                <MapVisualizer data={geojson} />
                            )}
                            {activeTab === "mapa" && geojson && (
                                <DownloadGeoButton
                                    geoJsonData={geojson}
                                    fileName={`analise_sabesp_${sessionId}.geojson`}
                                />
                            )}
                        </div>
                    </div>

                    <div className="tab-content">
                        {activeTab === "tabela" && (
                            rawTable ? renderMarkdownTables(rawTable) : <p>Nenhuma tabela encontrada</p>
                        )}
                        {activeTab === "texto" && (
                            <textarea readOnly value={report} />
                        )}
                        {activeTab === "mapa" && (
                            <MapVisualizer data={geojson} />
                        )}
                    </div>
                </div>
            </div>

        </div>

    );
}
export default Andre;